import React, { useEffect, useState } from "react";
import axios from "axios";
import "./PaginaInicio.css";
import "./HomeworkModule.css";
import Cabecera from "../Others/Cabecera";
import BarraSuperior from "../Others/BarraSuperior";
import BarraInferior from "../Others/BarraInferior";
import PiePagina from "../Others/PiePagina";
import NavigationIcon from "../Others/NavigationIcon";
import { useData } from "./DataContext";
import { mostrarTareaApi, descargarPDFApi } from "./constants";

export const MonitorHomework = () => {
  const { data, dataClase } = useData();
  const [tareas, setTareas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadingId, setDownloadingId] = useState(null);
  const [status, setStatus] = useState({ type: "", text: "" });

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        setLoading(true);
        const response = await axios.get(mostrarTareaApi, {
          params: { matricula: data.matricula },
        });
        setTareas(Array.isArray(response.data) ? response.data : []);
        setStatus({ type: "", text: "" });
      } catch (error) {
        console.error("Error al obtener las tareas:", error);
        setTareas([]);
        setStatus({
          type: "error",
          text: "No fue posible cargar los ejercicios de esta clase.",
        });
      } finally {
        setLoading(false);
      }
    };

    if (data?.matricula) {
      fetchTasks();
    }
  }, [data?.matricula]);

  const handleDescargarTarea = async (tarea) => {
    try {
      setDownloadingId(tarea.id_archivo);
      setStatus({ type: "", text: "" });
      const response = await axios.get(
        descargarPDFApi + "?id_archivo=" + tarea.id_archivo,
        { responseType: "blob" }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", tarea.nombre_archivo || "tarea.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al descargar la tarea:", error);
      setStatus({
        type: "error",
        text: "No fue posible descargar el archivo. Intenta nuevamente.",
      });
    } finally {
      setDownloadingId(null);
    }
  };

  return (
    <div className="contenedor-pagina">
      <Cabecera
        contenidosuperior={
          <BarraSuperior texto_cabecera={dataClase?.nombre_clase || "Ejercicios"} />
        }
        contenidoInferior={<BarraInferior />}
      />

      <main className="homework-module">
        <section className="homework-panel" aria-labelledby="monitor-homework-title">
          <header className="homework-hero">
            <div>
              <span className="homework-eyebrow">Seguimiento del curso</span>
              <h1 id="monitor-homework-title">Ejercicios</h1>
              <p>
                Consulta las tareas disponibles y descarga sus archivos de
                referencia.
              </p>
            </div>
            <div className="homework-summary">
              <strong>{tareas.length}</strong>
              <span>{tareas.length === 1 ? "archivo disponible" : "archivos disponibles"}</span>
            </div>
          </header>

          <div className="homework-body">
            {status.text && (
              <div className={"homework-status is-" + status.type} role="alert">
                {status.text}
              </div>
            )}

            {loading ? (
              <div className="homework-loading" aria-live="polite">
                <span className="homework-spinner" />
                <strong>Cargando ejercicios</strong>
                <p>Estamos consultando los archivos disponibles para esta clase.</p>
              </div>
            ) : tareas.length === 0 ? (
              <div className="homework-empty">
                <span className="homework-empty-icon">
                  <NavigationIcon name="tasks" size={28} />
                </span>
                <strong>Aún no hay ejercicios disponibles</strong>
                <p>Las tareas publicadas para esta clase aparecerán aquí.</p>
              </div>
            ) : (
              <div className="homework-list">
                {tareas.map((tarea, index) => {
                  const id = tarea.id_archivo || index;
                  const estaDescargando = downloadingId === tarea.id_archivo;

                  return (
                    <article className="homework-card" key={id}>
                      <span className="homework-icon">
                        <NavigationIcon name="content" size={25} />
                      </span>
                      <div className="homework-card-main">
                        <span className="homework-kicker">Archivo de tarea</span>
                        <h2>{tarea.nombre_archivo || "Tarea sin nombre"}</h2>
                        <p>Matrícula de clase: {tarea.matricula_clase}</p>
                      </div>
                      <div className="homework-card-actions">
                        <button
                          type="button"
                          className="homework-button"
                          disabled={estaDescargando}
                          onClick={() => handleDescargarTarea(tarea)}
                        >
                          <NavigationIcon name="deliverables" size={18} />
                          {estaDescargando ? "Descargando..." : "Descargar"}
                        </button>
                      </div>
                    </article>
                  );
                })}
              </div>
            )}
          </div>
        </section>
      </main>

      <PiePagina imagenSrc={require("../Assets/piepagina.jpg")} />
      <footer>Grupo Derecho & Progreso &copy; 2024</footer>
    </div>
  );
};
